import React from 'react'

export default function Code(props) {
    return (<code className="col s12 l6 m6">{props.code}</code>)
}
